import React from "react";
import { Box, Button, Grid, Tab, Tabs, Typography } from "@mui/material";
import {
  Dashboard as DashboardIcon,
  Group as UsersIcon,
  WarningAmber as AlertIcon,
} from "@mui/icons-material";

const UsersPageHeader = ({
  activeTab,
  onTabChange,
  onRefreshAlerts,
  refreshingAlerts = false,
}) => (
  <>
    <Grid item xs={12} style={{ textAlign: "start" }}>
      <Typography
        variant="h5"
        sx={{
          fontWeight: 500,
          color: "#3b3b3b",
          pl: 1,
          mb: 2,
          borderLeft: (theme) => `4px solid ${theme.palette.secondary.main}`,
          lineHeight: 1.5,
        }}
      >
        Panel de usuarios
      </Typography>
    </Grid>
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 3,
      }}
    >
      <Tabs
        value={activeTab}
        onChange={onTabChange}
        textColor="primary"
        indicatorColor="primary"
      >
        <Tab
          value="dashboard"
          icon={<DashboardIcon fontSize="small" />}
          iconPosition="start"
          label="Dashboard"
        />
        <Tab
          value="users"
          icon={<UsersIcon fontSize="small" />}
          iconPosition="start"
          label="Usuarios"
        />
        <Tab
          value="alerts"
          icon={<AlertIcon fontSize="small" />}
          iconPosition="start"
          label="Alertas"
        />
      </Tabs>
      {activeTab === "alerts" && (
        <Button
          variant="outlined"
          size="small"
          onClick={onRefreshAlerts}
          disabled={refreshingAlerts}
          sx={{ textTransform: "none" }}
        >
          Actualizar vencimientos
        </Button>
      )}
    </Box>
  </>
);

export default UsersPageHeader;
